"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardEditorContainer = /** @class */ (function (_super) {
    __extends(CardEditorContainer, _super);
    function CardEditorContainer(props) {
        return _super.call(this, props) || this;
    }
    CardEditorContainer.prototype.componentWillMount = function () {
        this.setState({ is_max: false });
    };
    CardEditorContainer.prototype.goBackClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    CardEditorContainer.prototype.goMaximizeClick = function () {
        var _this = this;
        this.setState({ is_max: !this.state.is_max }, function () {
            if (_this.props.onMaxButtonClick) {
                _this.props.onMaxButtonClick(_this.state.is_max);
            }
        });
    };
    CardEditorContainer.prototype.getButtonsRenderObject = function () {
        var _ret = [];
        if (this.props.showMaxButton) {
            if (this.state.is_max) {
                _ret.push(React.createElement(antd_1.Tooltip, { title: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C", key: 1 },
                    React.createElement(antd_1.Icon, { type: "fullscreen-exit", theme: "outlined", style: { cursor: "pointer", fontSize: "24px", marginRight: "5px", color: "#1890ff" }, onClick: this.goMaximizeClick.bind(this) })));
            }
            else {
                _ret.push(React.createElement(antd_1.Tooltip, { title: "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C", key: 2 },
                    React.createElement(antd_1.Icon, { type: "fullscreen", theme: "outlined", style: { cursor: "pointer", fontSize: "24px", marginRight: "5px", color: "#1890ff" }, onClick: this.goMaximizeClick.bind(this) })));
            }
        }
        _ret.push(React.createElement(antd_1.Tooltip, { title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C", key: 3 },
            React.createElement(antd_1.Icon, { type: "close-circle", theme: "outlined", style: { cursor: "pointer", fontSize: "24px", color: "#1890ff", marginLeft: "5px" }, onClick: this.goBackClick.bind(this) })));
        return _ret;
    };
    CardEditorContainer.prototype.getDialogStyle = function () {
        if (this.state.is_max) {
            return {
                width: "100%",
                // maxWidth: "1024px",
                //  minWidth: "690px",
                height: "100%",
                //  maxHeight: `${this.props.maxHeight}px`,
                // minHeight: `${this.props.maxHeight}px`,
                boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)"
            };
        }
        else {
            return {
                width: "80%",
                maxWidth: "1024px",
                minWidth: "690px",
                height: "80%",
                maxHeight: this.props.maxHeight + "px",
                minHeight: this.props.maxHeight + "px",
                boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)"
            };
        }
    };
    CardEditorContainer.prototype.render = function () {
        var _height = "calc( 100vh - " + this.props.state.UIHeaderHeightPx + "px )";
        if (this.props.customHeight) {
            _height = this.props.customHeight;
        }
        return (React.createElement("div", { style: {
                height: _height,
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            } },
            React.createElement(antd_1.Card, { title: React.createElement("div", { style: { textAlign: "center" } }, this.props.title), bordered: true, hoverable: false, extra: React.createElement("div", { style: { display: "flex", flexDirection: "row", flexWrap: "nowrap" } }, this.getButtonsRenderObject()), style: this.getDialogStyle() }, this.props.children)));
    };
    return CardEditorContainer;
}(React.Component));
exports.default = CardEditorContainer;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/containers/CardEditorContainer.tsx
// module id = 14
// module chunks = 0